import React from "react";
import { cn } from "../utils";

// VARIANTS = "rounded" | "flat"
const Input = React.forwardRef(({
    variant = "rounded",
    color = "primary",
    fullWidth = false,
    className,
    startIcon,
    isImage = true,
    style,
    iconStyle,
    containerClasses,
    labelClasses,
    label,
    required = false,
    error = false,
    errorText = "",
    ...rest
}, ref) => {
    return (
        <div className={cn("input-container", fullWidth ? "full" : "", containerClasses)}>
            {label && (
                <label className={cn("input-label", labelClasses)}>
                    {label}{required && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
                </label>
            )}
            <input
                ref={ref}
                className={cn("input-base", variant, error ? "error" : "", className)}
                style={{paddingLeft: startIcon ? "45px" : "10px", ...style}}
                {...rest}
            />
            {startIcon && isImage && (
                <img
                    className="input-start-icon-image"
                    src={startIcon}
                    alt="Search"
                    style={{ width: "22px", height: "22px", ...iconStyle?.style }}
                    {...iconStyle}
                />
            )}
            {startIcon && !isImage ? (
                <span className="input-start-icon">
                    {startIcon}
                </span>
            ) : null}
            {errorText && (<p className="error-text">{errorText}</p>)}
        </div>
    )
})

Input.displayName = "Input";

export default Input;